// @ts-nocheck
// this file was patched by @terra

import { z } from 'zod';
import { WebAppDraftStrategySchema } from '../inputTypeSchemas/WebAppDraftStrategySchema'
import { EgressStrategySchema } from '../inputTypeSchemas/EgressStrategySchema'
import { SurfaceDeletionStatusSchema } from '../inputTypeSchemas/SurfaceDeletionStatusSchema'

/////////////////////////////////////////
// EXTERNAL NETWORK SCHEMA
/////////////////////////////////////////

export const ExternalNetworkSchema = z.object({
  webAppDraftStrategy: WebAppDraftStrategySchema.nullable(),
  egressStrategy: EgressStrategySchema,
  deletionStatus: SurfaceDeletionStatusSchema.nullable(),
  id: z.string(),
  tenantId: z.string().nullable(),
  name: z.string(),
  organizationName: z.string().nullable(),
  scanProfileId: z.string(),
  smokeTestEnabled: z.boolean(),
  detectWebAppsEnabled: z.boolean().nullable(),
  dnsServerIps: z.string().array(),
  tailscaleNetworkId: z.string().nullable(),
  isEnabled: z.boolean(),
  deletionError: z.string().nullable(),
  createdAt: z.coerce.date(),
  updatedAt: z.coerce.date(),
})

export type ExternalNetwork = z.infer<typeof ExternalNetworkSchema>

export default ExternalNetworkSchema;
